export default __webpack_public_path__ + "static/media/CardHeaderGroup.bce95c8e.svg";